export function sendEventToHost(_a) {
    var event = _a.event, eventType = _a.eventType;
    window.parent.postMessage({
        type: 'host/event',
        data: {
            eventType: eventType,
            event: event,
        },
    }, '*');
}
